import CareCreditIcon from '../../../../../../../assets/carecredit_logo.svg';
import { usePatientProfile } from '../../../../../../../hooks/use-patient-profile';
import AccordionContent from '../../../../../../shared/accordion/accordion-content';
import AccordionSection from '../../../../../../shared/accordion/accordion-section';
import { formatDollarAmount } from '../../../utils/format-dollar-amount';

export const CareCreditSection = () => {
  const { careCreditInfo } = usePatientProfile();

  return careCreditInfo && careCreditInfo.preStatus && careCreditInfo.preApprovedAmount ? (
    <AccordionSection
      header={
        <>
          {(() => {
            switch (careCreditInfo.preStatus) {
              case 'Preapproved':
                return `CareCredit Pre-Approved`;
              case 'Cardholder':
                return 'CareCredit Current Cardholder';
            }
          })()}
          <img src={CareCreditIcon} alt="" style={{ width: '18px', marginLeft: '6px' }} />
        </>
      }
    >
      {careCreditInfo.preStatus == 'Preapproved' && (
        <AccordionContent>
          <label>{formatDollarAmount(careCreditInfo.preApprovedAmount)}</label>
        </AccordionContent>
      )}
    </AccordionSection>
  ) : null;
};
